const Footer=()=>{
    return(
        <>
        <br/><br/><br/><br/><br/>
        <footer className="mt-5 p-2 bg-dark fixed-bottom">
            <center>
                <small className="text-muted mt-5">Copyright Norrenberger 2023. All Rights Reserved</small>
            </center>
        </footer>
        </>
        
    )
}

export default Footer;